import { useEffect, useLayoutEffect, useRef, useState } from "react";
import { useGlobalContext } from "@/global/GlobalContext";
import UserDashboardLayout from "@/layouts/user-dashboard/UserDashboard";
import TransactionAPI from "@/app/api/di-sana/transaction/transaction";
import { paymentStatus, purchaseTabTables } from "@/app/utils/constants";
import { useNavigate, useSearchParams } from "react-router-dom";
import clsx from "clsx";
import ContainerSkeleton from "@/components/skeletons/ContainerSkeleton";
import { formatNumber } from "@/app/utils/helpers";
import ImageSkeleton from "@/components/skeletons/ImageSkeleton";
import { Button } from "@/components/Button";
import ProcessModal from "@/components/ProcessModal";
import useSnap from "@/hooks/useSnap";
import Pagination from "@/components/Pagination";
import Pill from "@/components/Pill";
const transactionApi = new TransactionAPI()

const Purchase = () => {
  const { notifyError, notifySuccess, locSearch, processSaveModal } = useGlobalContext()
  const [purchase, setPurchase] = useState({})
  const [selectedPurchase, setSelectedPurchase] = useState(null)
  const [onReq, setOnReq] = useState(false)
  const [totalPurchases, setTotalPurchases] = useState(false)
  const [modalContent, setModalContent] = useState(null)
  const [searchParams, setSearchParams] = useSearchParams()
  const [snapToken, setSnapToken] = useState("")
  const navigate = useNavigate()
  const page = useRef(1)
  const sectionIndex = useRef(0)
  const [lastPage, setLastPage] = useState(0)
  const pageNumbers = useRef([])
  const buyAgainId = useRef(0)
  const activeStatus = useRef("all")
  // const hasLoaded = useRef(false)
  const pageLimit = 5
  const { snapPopUp } = useSnap()

  useLayoutEffect(() => {
    const queryParams = new URLSearchParams(locSearch)
    const currPage = queryParams.get("page")
    const currStatus = queryParams.get("status") ? queryParams.get("status") : "all"
    const shownPurchase = purchaseTabTables.find(val => val.status == currStatus)
    let activeIdx = 0

    if (shownPurchase) activeIdx = shownPurchase.idx

    handleActiveTab(activeIdx)
    if (currPage) page.current = parseInt(currPage)
    if (currStatus) activeStatus.current = currStatus
  }, [])

  useEffect(() => {
    loadData()
  }, [])

  useEffect(() => {
    if (purchase && purchase.transactions?.length > 0) setTotalPurchases(purchase.transactions.reduce((acc, purchase) => acc + purchase.total_payment, 0))
  }, [purchase])

  useEffect(() => {
    initPagination(lastPage)
  }, [lastPage])

  // useEffect(() => {
  //   if (processSaveModal && isBuyAgain) processModal()
  // }, [processSaveModal, isBuyAgain])

  const onClickTab = async (idx) => {
    handleActiveTab(idx)
    // const shownPurchase = purchaseStatus.find(val => val.id == idx)

    // if (Object.keys(shownPurchase).length > 0) { // TODO: untuk sementara karena kiriminaja belum terintegrasi
    if (page.current > 1) page.current = 1
    setSearchParams({ status: purchaseTabTables[idx].status, page: page.current })
    activeStatus.current = purchaseTabTables[idx].status
    await loadData()
    // }
  }

  const handleActiveTab = (activeIdx) => {
    const tabs = document.querySelectorAll(".tab")
    const tab = Array.from(tabs).find((t, i) => { return i == activeIdx })

    for (const t of tabs) {
      if (!tab.isEqualNode(t)) {
        t.classList.remove("activeTab", "text-[#6e605d]")
        t.classList.add("text-white")
      }
    }

    tab?.classList.add("activeTab", "text-[#6e605d]")
    tab?.classList.remove("text-white")
  }

  const initPagination = (rowDataLength) => {
    const currPage = searchParams.get("page")
    if (currPage > pageLimit) sectionIndex.current = Math.floor((currPage - 1) / pageLimit)
    if (rowDataLength >= pageLimit) {
      const start = sectionIndex.current * pageLimit + 1
      for (let i = 0; i < pageLimit; i++) {
        let calculated = start + i

        if (calculated > rowDataLength) break
        pageNumbers.current.push(calculated)
      }
    } else {
      pageNumbers.current = Array.from({ length: rowDataLength }, (_, i) => i + 1)
    }
  }

  const toPage = async (currPage) => {
    page.current = parseInt(currPage)

    setSearchParams({ status: activeStatus.current, page: currPage })
    await loadData()
  }

  const toPrevPage = async () => {
    const currPage = page.current
    if (currPage == pageNumbers.current[0]) {
      sectionIndex.current--
      const end = sectionIndex.current * (pageLimit) + 1
      const currPageNumbers = Array.from({ length: pageLimit }, (_, i) => end + i)
      pageNumbers.current = currPageNumbers
    }
    page.current = currPage - 1

    setSearchParams({ status: activeStatus.current, page: page.current })
    await loadData()
  }

  const toNextPage = async () => {
    const currPage = page.current
    let currPageNumbers = []

    if (currPage == pageNumbers.current[pageLimit - 1]) {
      sectionIndex.current++
      const start = sectionIndex.current * (pageLimit) + 1
      for (let i = 0; i < pageLimit; i++) {
        let calculated = start + i

        if (calculated > lastPage) break
        currPageNumbers.push(calculated)
      }

      pageNumbers.current = currPageNumbers
    }
    page.current = currPage + 1

    setSearchParams({ status: activeStatus.current, page: page.current })
    await loadData()
  }

  const showDetail = (id) => {
    const selected = purchase.transactions.find((p) => p.id == id)
    setSnapToken(selected.snap_token)
    setSelectedPurchase(selected)

    setModalContent({
      title: "Detail Transaction",
      paymentStatus: selected.payment_status,
      innerContent: selected,
      isOpen: true,
      buyAgain: activeStatus.current != purchaseTabTables[1].status,
      payNow: activeStatus.current == purchaseTabTables[1].status
    })
    buyAgainId.current = id
    // setIsBuyAgain(true)
  }

  const payNow = (purchase) => {
    snapPopUp(purchase.snap_token, "snapContainer")
  }

  const processModal = () => {
    if (activeStatus.current == purchaseTabTables[1].status) {
      snapPopUp(snapToken)
    } else {
      buyAgain()
    }
  }

  // API request
  const loadData = async () => {
    setOnReq(true)
    try {
      let param = {
        status: activeStatus.current,
        page: page.current
      }
      const { data } = await transactionApi.getAllTransactions(param)
      setPurchase(data.data)
      setLastPage(data.data.last_page)
    } catch (err) {
      notifyError(err.message)
    }
    setOnReq(false)
  }

  const buyAgain = async () => {
    setOnReq(true)
    try {
      const { data } = await transactionApi.buyAgain(buyAgainId.current)
      // notifyError(data.message)
      if (data.code == 200) {
        setModalContent({ isOpen: false })
        notifySuccess("Order has been added again to your cart!")
        navigate("/cart")
        // setIsBuyAgain(false)
      }
    } catch (err) {
      notifyError(err.message)
    }
    setOnReq(false)
  }

  return (
    <>
      <ProcessModal pModalContent={modalContent} processModal={processModal}>
        <div>
          {selectedPurchase &&
            <>
              {selectedPurchase.transaction_item_histories.map((m, i) =>
                <div key={i} className={clsx("w-full flex justify-between items-center border-b-[1.5px] border-b-[#bc9c5c]", { "border-opacity-20": i < selectedPurchase.transaction_item_histories.length - 1, "border-opacity-50": i >= selectedPurchase.transaction_item_histories.length - 1 })}>
                  <div className="py-5 px-3 md:px-6">
                    <div className="flex">
                      <div className="mr-4 lg:mr-8">
                        <ImageSkeleton src={m.product_photo} isDarker custCls="object-cover h-[90px] sm:h-[100px] md:h-[148px] w-[110px] sm:w-[130px] md:w-[190px] border-2 border-[#dcd6d2]" custH="h-[90px] sm:h-[100px] md:h-[148px]" custW="w-[110px] sm:w-[130px] md:w-[190px]" />
                      </div>
                      <div className="mt-2">
                        <span className="text-[#6e605d] font-agcasmlt font-normal text-lg sm:text-xl lg:text-2xl">{m.product_name}</span>
                        {/* <span className="text-[#6e605d] font-light font-agcasmlt text-lg md:text-xl block">Variant:</span> */}
                        <span className="block text-[#6e6060] font-light font-agcasmlt text-xs sm:text-sm lg:text-base opacity-80">Quantity: {m.product_qty}</span>
                      </div>
                    </div>
                  </div>
                  <div className="py-5 px-3 md:px-6">
                    <div className="flex justify-center">
                      <span className="text-[#6e605d] font-light font-agcasmlt text-sm sm:text-base lg:text-xl">IDR {formatNumber(m.product_price)}</span>
                    </div>
                  </div>
                </div>
              )}
              <div className="mt-5">
                <div className="px-3 md:px-6">
                  <div className="flex justify-between items-end mb-1.5 md:mb-3">
                    <span className="text-[#6e605d] font-agcasmlt font-light text-base md:text-md opacity-80">Order ID</span>
                    <span className="text-[#6e605d] font-agcasmlt font-light text-base md:text-md opacity-80">{selectedPurchase.order_id}</span>
                  </div>
                  <div className="flex justify-between items-end">
                    <span className="text-[#6e605d] font-light font-agcasmlt text- md:text-lg">Total</span>
                    <span className="text-[#6e605d] font-light font-agcasmlt text- md:text-lg">IDR {formatNumber(selectedPurchase.total_payment)}</span>
                  </div>
                </div>
              </div>
            </>
          }
        </div>
      </ProcessModal>
      <UserDashboardLayout>
        <div className="sm:hidden mb-2">
          <span className="text-[#bc9c5c] font-light font-agcasmlt text-[20px] sm:text-[16px] lg:text-[24px] leading-[20px] sm:leading-[16px] lg:leading-[24px]">My Purchase</span>
        </div>
        <div className="pb-10 w-full sm:w-[77%] lg:w-4/5 ">
          <div className="border-[1.5px] border-[#bc9c5c]">
            <div className="w-full overflow-x-auto">
              <div className="w-[1100px] bg-[#bc9c5c] flex">
                {/* 20%, total 7 */}
                {purchaseTabTables.map((p, i) =>
                  <div key={i} id={p.tabId} className={clsx("tab activeTab font-agcasmlt font-light text-sm sm:text-xl text-left pt-4 pb-2 px-3 md:px-6", { "w-[10%]": i < 1, "w-1/5": i > 0 })}>
                    <button type="button" onClick={() => onClickTab(i)}>{p.name}</button>
                  </div>
                )}
              </div>
            </div>
            {onReq ?
              <>
                <div className="border-b-[1.5px] border-b-[#bc9c5c] w-full flex justify-between items-center">
                  <div className="py-5 px-3 md:px-6">
                    <div className="flex">
                      <div className="max-lg:hidden mr-4 lg:mr-8">
                        <ContainerSkeleton custH="h-[90px] sm:h-[100px] md:h-[148px]" custW="w-[110px] sm:w-[130px] md:w-[190px]" />
                      </div>
                      <div className="mt-2">
                        <ContainerSkeleton custH="h-[18px] md:h-5" custW="w-20" />
                        <ContainerSkeleton custH="h-[18px] md:h-5" custW="w-20" custCls="mt-1" />
                      </div>
                    </div>
                  </div>
                  <div className="py-5 px-3 md:px-6">
                    <div className="flex justify-center">
                      <ContainerSkeleton custH="h-[18px] md:h-5" custW="w-20" />
                    </div>
                  </div>
                </div>
              </>
              :
              purchase &&
                purchase.transactions?.length > 0 ?
                purchase.transactions.map((transaction, i) => (
                  <div key={i} className="border-b-[1.5px] border-b-[#bc9c5c] w-full flex justify-between items-center">
                    <div className="py-5 px-3 md:px-6">
                      <div className="flex">
                        {/* TODO: gambar bisa ditampilkan posisinya sejajar menurun aja */}
                        <div className="max-lg:hidden mr-4 lg:mr-8">
                          <button onClick={() => showDetail(transaction.id)}>
                            <ImageSkeleton isWFull={false} src={transaction?.transaction_item_histories[0].product_photo} isDarker custCls="object-cover h-[90px] sm:h-[100px] md:h-[148px] w-[110px] sm:w-[130px] md:w-[190px] border-2 border-[#dcd6d2]" custH="h-[90px] sm:h-[100px] md:h-[148px]" custW="w-[110px] sm:w-[130px] md:w-[190px]" />
                          </button>
                        </div>
                        <div className="mt-2 grid grid-rows-2">
                          <div>
                            <div className="flex items-start">
                              <button onClick={() => showDetail(transaction.id)}>
                                <span className="text-[#6e605d] font-agcasmlt text-lg sm:text-xl lg:text-2xl font-normal">{transaction?.order_id}</span>
                              </button>
                              {/* <div> */}
                              {/* 
                            TODO: status warna
                            pending: yellow
                            processing: orange/blue
                            completed: green
                            fail: red
                             */}
                              {/* <span className={clsx("font-light font-agcasmlt text-[12px] tracking-wider leading-3 rounded-full text-white mb-0 ml-1 pt-1 pb-0.5 px-2", { "bg-red-500": transaction.payment_status == paymentStatus[5] || transaction.payment_status == paymentStatus[4], "bg-green-500": transaction.payment_status == paymentStatus[3], "bg-yellow-500": transaction.payment_status == paymentStatus[0], "bg-blue-500": transaction.payment_status == paymentStatus[1] || transaction.payment_status == paymentStatus[2].status })}>{
                                  transaction.payment_status == paymentStatus[5] ? "Failed" : transaction.payment_status == paymentStatus[4] ? "Canceled" : transaction.payment_status == paymentStatus[3] ? "Completed" : transaction.payment_status == paymentStatus[0] ? "Unpaid" : "Paid"
                                }</span> */}
                              {transaction &&
                                <Pill status={transaction.payment_status} />
                              }
                            </div>
                            <span className="block text-[#6e6060] font-light font-agcasmlt text-base opacity-80">Order quantity: {transaction?.total_qty}</span>
                            {/* <span className="text-[#6e605d] font-light font-agcasmlt text-lg md:text-xl block">Variant:</span> */}
                          </div>
                          <div className="flex items-end">
                            <span className="text-[#6e605d] font-light font-agcasmlt text-lg md:text-xl">IDR {formatNumber(transaction.total_payment)}</span>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div className="py-5 px-3 md:px-6">
                      <div className="flex justify-center">
                        {transaction?.payment_status == paymentStatus[0] ?
                          <Button processBtn onClickBtn={() => payNow(transaction)} type="submit" title="Pay now" custCls="text-base  font-extralight px-2 pt-2 pb-1" />
                          :
                          <Button processBtn onClickBtn={() => showDetail(transaction.id)} title="Show Detail" onlyBorder custCls="border-[#dcd6d2] text-base font-light px-2 pt-2 pb-1" />
                        }
                        {/* <span className="text-[#6e605d] font-light font-agcasmlt text-lg md:text-xl">IDR {formatNumber(purchase.total_payment)}</span> */}
                      </div>
                    </div>
                  </div>
                ))
                :
                <div className="border-b-[1.5px] border-b-[#bc9c5c] py-5 px-6 text-center text-gray-500">No purchase available.</div>
            }
            <div className="flex justify-end gap-8 sm:gap-16 lg:gap-32 py-8 px-3 md:px-6">
              <span className="text-[#bc9c5c] font-light font-agcasmlt text-xl md:text-2xl">Order Total:</span>
              {onReq ?
                <ContainerSkeleton custH="h-[18px] md:h-5" custW="w-20" />
                :
                purchase &&
                  purchase.transactions?.length > 0 ?
                  <span className="text-[#bc9c5c] font-light font-agcasmlt text-lg md:text-xl lg:text-2xl">IDR {formatNumber(totalPurchases)}</span>
                  :
                  <span className="text-[#bc9c5c] font-light font-agcasmlt text-lg md:text-xl lg:text-2xl">IDR 000.000</span>
              }
            </div>
          </div>
          <div>
            <ol className="flex mt-4 lg:mt-2 justify-center">
              {onReq ?
                Array.from({ length: 5 }, (_, i) => (
                  <li key={i}>
                    <ContainerSkeleton custH="h-8" custW="w-8" />
                  </li>
                ))
                :
                (purchase && purchase.transactions?.length > 0) &&
                <Pagination dataArr={purchase} page={page.current} pageNumbers={pageNumbers.current} goToPage={(page) => toPage(page)} goToPrevPage={toPrevPage} goToNextPage={toNextPage} />
              }
            </ol>
          </div>
        </div>
      </UserDashboardLayout>
    </>
  )
}

export default Purchase;